<template>
  <div class="navbarMobile">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <div class="logoTxt"><span class="mw">{{$route.name==='mobileHomeMN'?'ᠣᠶᠤᠨ ᠮᠡᠳᠡᠭᠡ ᠵᠠᠩᠭᠢ ᠮᠡᠷᠭᠡᠵᠢᠯ':$route.meta.title}}</span></div>
    <div class="right-menu">
      <router-link to="/mobileHome" class="mw" style="line-height: 1.5">
        ᠬᠢᠲᠠᠳ<br> ᠬᠡᠪ
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device'
    ])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>

<style lang="scss" scoped>
.navbarMobile {
  height: 64px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
.logoTxt{
  line-height: 1.5;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  width: 80px;
  display: flex;
  justify-content: center;
 span{
   max-height: 50px;
   height: min-content;
   width: auto;
   display: inherit;
 }
}
  .hamburger-container {
    line-height: 4.6rem;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;
    display: flex;
    align-items: center;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    color: #0C0C0C;
    line-height: 6.4rem;
    font-size: 2rem;
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/mobieLayoutMn/components/Navbar.vue